<template>
	<div class=" emailConfirmContainer align-items-center bg-grey200">
		<section class="container ">
			<div class="card confirmationCard">
				<div class="text-center">
					<h5>
						Email Verified
					</h5>
					<img
						src="@/assets/img/sent.svg"
						alt
						height="50px"
						width="50px"
						style="vertical-align: top"
						class="my-3"
					/>
					<p class="mt-2">Hello {{ username }},</p>
					<div>
						<p>Your email has been verified.</p>
						<p>
							your account is now active
						</p>
						<p>Please use the link below to login and enjoy Ibaka TV</p>
					</div>
					<div class="my-3">
						<button class="btn btn-primary" @click="redirecttToAppURL()">
							Continue
						</button>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "ConfirmEmailverification",
	components: {},
	created() {
		if (this.$store.state.user.userInfo.profile.first_name == "undefined") {
			this.$store.dispatch("account").then((res) => {
				if (res) {
					if (res.response.profile.name) {
						this.username = res.response.profile.first_name;
					}
				} else {
					this.username = "User";
				}
			});
		} else {
			this.username = this.$store.state.user.userInfo.profile.first_name;
		}
	},
	methods: {
		redirecttToAppURL() {
			window.open(
				this.$store.getters.getGlobalConfigs.app_branchio_url,
				"_self"
			);
		},
	},

	data() {
		return {
			username: null,
		};
	},
};
</script>

<style scoped>
.emailConfirmContainer {
	height: 100vh;
	display: flex;
}
.confirmationCard {
	border-radius: 12px;
	transition: all 0.5s ease;
	max-width: 455px;
	padding: 25px;
	margin: auto;
}
h5 {
	color: #679f3d;
}
</style>
